import { render } from "./questions-list.vue?vue&type=template&id=1bb88f9f&scoped=true"
import script from "./questions-list.vue?vue&type=script&lang=js"
export * from "./questions-list.vue?vue&type=script&lang=js"

import "./questions-list.vue?vue&type=style&index=0&id=1bb88f9f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb88f9f"]])

export default __exports__